import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/3-2_questioncircle.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const QuestionCircle: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default QuestionCircle;
